<template>
    <div class="convention-list">
        <breadcrumb
            :section="{ title: 'Conventions Collectives', to: '/espace-client/conventions-collectives' }"
        />
        <search v-model="conventions" @query="onQuery" mode="results" :user="user" />
        <div class="wrapper">
            <search-results :conventions="conventions" :query="query" />
        </div>
    </div>
</template>

<script>
import Search from "../search/Search.vue";
import SearchResults from "../search/SearchResults.vue";
import scrollManager from "./managers/scrollManager";
export default {
    components: { Search, SearchResults },
    props: ["user"],
    data() {
        return {
            conventions: null,
            query: null,
        };
    },
    mounted() {
        scrollManager.scrollTop();
    },
    methods: {
        onQuery(query) {
            this.query = query;
        },
    },
};
</script>

<style scoped lang="sass">
.wrapper
    margin: $grid-gutter * 2 0
    padding: $grid-gutter 0 $grid-gutter * 2 0
    background: $color-background
    min-height: 400px
</style>
